export default __webpack_public_path__ + "static/media/email.5f3effd2.svg";